import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

/**
 * Read-only projection of a case contact, used only by the Client Detail header badges.
 *
 * The store keys records by model name, and the Client Detail parent route loads in
 * parallel with the Contacts tab's child loader. Sharing `ContactModel` would make the
 * two queries race over the same `contact` slot, so the header gets its own model.
 */
export default class ClientDetailContactModel extends BaseModel {
  @attr("string") relationType;
}
